/** @format */

import { Paper, Grid, Typography, Backdrop } from '@mui/material';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { makeStyles } from '@mui/styles';
import { CircularProgress } from '@mui/material';
import { Icons } from 'components';

export default function UploadMedia({ file, setFile, disabled = true }) {
  // --STAETS--//

  // --SERVICES--//

  // --OTHER FUNCTIONS--//
  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0]);
  }, []);

  // --HOOKS--//
  const classes = useStyles();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <Paper className={classes.uploadPaper} elevation={0}>
      <Backdrop open={disabled} className={classes.backdrop} />
      <div {...getRootProps()}>
        <input {...getInputProps()} multiple={false} disabled={disabled} />
        <Grid
          justifyContent="flex-start"
          alignItems="center"
          container
          direction="row"
          item
          wrap="nowrap"
          xs={12}
          className={classes.uploadPaperBlock}
          style={disabled ? { visibility: 'hidden' } : {}}
        >
          <Grid justifyContent="center" item>
            {file ? (
              <span className={classes.dragHereIcon}>
                <Icons icon="Drag" color="#2b3990" size="35" />
              </span>
            ) : isDragActive ? (
              <span className={classes.dragHereIcon}>
                <Icons icon="plusCircle" color="#2B3990" size="35" />
              </span>
            ) : (
              <span className={classes.dragHereIcon}>
                <Icons icon="NoteAdd" color="#2B3990" size="35" />
              </span>
            )}
          </Grid>
          <Grid justifyContent="center" item>
            <Typography className={classes.dragHereText} variant="h5" align="center">
              {file
                ? file?.name
                : isDragActive
                  ? 'فایل را اینجا رها کنید'
                  : 'فایل را به اینجا بکشید یا انتخاب کنید'}
            </Typography>
          </Grid>
        </Grid>
      </div>
      {
        disabled &&
        <div style={{ position: 'absolute', width: '100%', height: '100%', top: '0', right: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress size={28} className={classes.buttonProgress} />
        </div>
      }
    </Paper>
  );
}

const useStyles = makeStyles((theme) => {
  return {
    uploadPaper: {
      position: 'relative',
      marginInlineStart: '8px',
      background: theme.palette.grey[100],
      border: `1px dotted ${theme.palette.primary.light}`,
      padding: theme.spacing(4),
      boxSizing: 'border-box',
      borderRadius: 10,
      cursor: 'pointer',
      transform: 'scale(1)',
      width: '100%',
      marginInlineEnd: theme.spacing(1),
      overflow: 'hidden',
      transition: 'ease .2s transform,ease .2s border',
      '&:hover': {
        borderColor: theme.palette.grey[700],
      },
      '&:active': {
        transform: 'scale(.98)',
      },
      '& *': {
        outline: 'none',
      },
    },
    dragHereIcon: {
      fontSize: 50,
      color: theme.palette.grey[600],
    },
    dragHereText: {
      color: theme.palette.grey[600],
      fontFamily: 'Vazir',
      paddingTop: theme.spacing(2),
      marginInlineStart: theme.spacing(1),
    },
    fileFormat: {
      direction: 'rtl',
      fontSize: 14,
      color: theme.palette.grey[600],
    },
    backdrop: {
      background: theme.palette.grey[100],

    },
    loadingUpload: {
      width: '100%',
      position: 'absolute',
      justifyContent: 'center',
      alignItems: 'center',
      top: '0',
      height: '100%',
      display: 'flex',
    },
    uploadPaperBlock: {
      display: 'flex',
      flexDirection: 'column',
    },
  };
});
